import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { EditGenericDocumentFormViewProps } from "models/propTypes/documentPropTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { DocumentFormTypes } from "models/formTypes";
import { FormEnums } from "models/enums";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { GenericForm } from "components/common";
//#endregion

const EditGenericDocumentForm: ForwardRefRenderFunction<FormHandles, EditGenericDocumentFormViewProps> = (
  props,
  ref
) => {
  return (
    <GenericForm<DocumentFormTypes.EditGenericDocument>
      formRef={ref}
      {...props}
      fields={{
        name: {
          label: TranslationKeys.Common.Name,
          type: FormEnums.FormFieldType.TEXT,
        },
      }}
    />
  );
};

export default forwardRef(EditGenericDocumentForm);
